/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdDto } from '../../models/ad-dto';

export interface AdControllerFindOne$Params {

/**
 * ad 알림 ID
 */
  id: string;
}

export function adControllerFindOne(http: HttpClient, rootUrl: string, params: AdControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<AdDto>> {
  const rb = new RequestBuilder(rootUrl, adControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdDto>;
    })
  );
}

adControllerFindOne.PATH = '/api/ad/{id}';
